<template>
    <div class="container-fluid p-3">
        <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex flex-row gap-2">
                <a class="link-primary" @click.prevent="$router.back()" href="#">
                    <inline-svg class="back-arrow mb-2" style="margin-top: 11px" src="/assets/img/icons/arrow-left.svg"/>
                </a>
                <div>
                    <div class="title">Favorites</div>
                </div>
            </div>
            <div class="d-flex align-items-center align-self-end">
                <form-input class="me-2" style="max-width: 320px"
                            v-model="filters.query"
                            placeholder="Search in Favorites"
                            @keypress.enter="search">
                    <template slot="prepend">
                        <inline-svg src="/assets/img/icons/search-icon.svg"></inline-svg>
                    </template>
                </form-input>
            </div>
        </div>
        <div class="divider --vertical-24"></div>
        <div v-if="favoriteCardDecks.length" class="deck-card-list mt-2" :class="{loading: loading.data}">
            <template v-for="cardDeck in favoriteCardDecks">
                <deck-card-partner v-if="cardDeck.corporateBrand"
                                   :cardDeck="cardDeck"
                                   :communityCard="true">
                </deck-card-partner>
                <deck-card-regular v-else
                                   :cardDeck="cardDeck"
                                   :communityCard="true">
                </deck-card-regular>
            </template>
        </div>
        <no-card-decks v-else-if="!loading.data"
                subtitle="You don't have any Card Decks added to your favorites. To add one, please go to Community Library and pick your favorite!">
            <btn class="btn-primary" @click="$router.push({ name: 'card.decks'})">
                <inline-svg class="me-1" src="/assets/img/icons/file-plus-01.svg"></inline-svg>
                Go to Community Library
            </btn>
        </no-card-decks>

    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import {modelListMixin} from "@/mixins/modelListMixin";
import DeckCardPartner from "@/components/DeckCardPartner.vue";
import DeckCardRegular from "@/components/DeckCardRegular.vue";
import NoCardDecks from "@/components/NoCardDecks.vue";

export default {
    name: "CardDeckFavorites",
    components: {NoCardDecks, DeckCardRegular, DeckCardPartner, UserAvatar},
    mixins: [modelListMixin],
    data() {
        return {
            favoriteCardDecks: [],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading.data = true;
            this.$http.post("/deck/favorite-decks", this.filters)
                .then((res) => {
                    this.favoriteCardDecks = res.body.data;
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
